import Style from './style';

export default function OverviewWidget({ config = [] }) {
  return (
    <Style className="flex">
      {config.map((conf, i) => (
        <div className="conf-column flex-1" key={`column-${i}`}>
          <label className="mb-2">{conf.label}</label>
          <h2>{Number(conf.value || 0).toLocaleString('en-us')}</h2>
        </div>
      ))}
    </Style>
  )
}
